<template>
<div>
  <v-card style="border-radius: 30px;">
    <v-card-text>
      <v-layout row wrap>
        <v-flex xs12 sm12 md6 lg6 style="padding: 15px 15px 0px 15px; font-size: 18px;">Line Wise Mapping</v-flex>
        <v-flex xs12 sm12 md12 lg2 style="padding: 15px 15px 0px 15px"></v-flex>

        <v-flex xs12 sm12 md6 lg4 style="float: right; padding: 15px 15px 0px 0px">
          <v-menu
              v-model="line_wise_date_menu"
              :close-on-content-click="false"
              :nudge-right="-200"
              transition="scale-transition"
              offset-x
              min-width="auto"
              style="padding-top: 10px;"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                  v-model="filters.line_wise_filter_date"
                  label="Date"
                  readonly
                  v-bind="attrs"
                  v-on="on" clearable solo flat
              ></v-text-field>
            </template>
            <v-date-picker
                v-model="filters.line_wise_filter_date"
                @input="line_wise_date_menu = false"
                :max="current_date"
            ></v-date-picker>
          </v-menu>
        </v-flex>
      </v-layout>


      <v-flex xs12 sm12 md12 lg12>
        <v-data-table
            :headers="headers"
            :items="mappedData"
            class="elevation-1"
            :pagination.sync="pagination"
            :loading="loader"
            :total-items="total_items"
            :rows-per-page-items="[5, 10, 20, 100]"
            no-results-text="Loading... Please wait"
        >
          <template v-slot:items="props">
            <td>{{ props.item.name }}</td>
            <td v-if="filters.line_wise_filter_date == current_date">{{ props.item.journey_ongoing }}</td>
            <td v-else>{{ " - " }}</td>

            <td v-if="filters.line_wise_filter_date == current_date">{{ props.item.journey_completed }}</td>
            <td v-else>{{ " - " }}</td>

            <td v-if="filters.line_wise_filter_date != current_date">{{ props.item.missed_trains }}</td>
            <td v-else>{{ " - " }}</td>

            <td>{{ props.item.mapped_trains }}</td>

            <td>{{ props.item.total_trains }}</td>

            <td v-if="filters.line_wise_filter_date != current_date">{{ props.item.percentage + " %"  }}</td>
            <td v-else>{{ " - " }}</td>
          </template>
        </v-data-table>
      </v-flex>
    </v-card-text>
  </v-card>
  <v-snackbar v-model="snackbar.display" :color="snackbar.color" :top="snackbar.top" :bottom="snackbar.bottom"
              :left="snackbar.left" :right="snackbar.right" :timeout="snackbar.timeout">
    {{ snackbar.message }}
    <v-btn
        text
        dark
        @click="snackbar.display = false"
    >
      <v-icon
          right
          color="white"
      >
        close
      </v-icon>
    </v-btn>
  </v-snackbar>
</div>
</template>

<script>
import moment from "moment";

export default {
  name: "LineWiseMappingReportDashboard",
  watch: {
    pagination: {
      handler() {
        this.getLineWiseMappedData();
      }
    },
    "filters.line_wise_filter_date" : function (val){
      if(val){
       this.getLineWiseMappedData();
      }
    }
  },
  data(){
    return{
      line_wise_date_menu: false,
      filters:{
        line_wise_filter_date: moment().format('YYYY-MM-DD')
      },
      headers: [
        { text: 'Name', align: 'left', sortable: false },
        { text: 'Ongoing', align: 'left', sortable: false },
        { text: 'Completed', value: 'completed',align: 'left' },
        { text: 'Missed', value: 'missed' },
        { text: 'Mapped', value: 'mapped' },
        { text: 'Total', value: 'total' },
        { text: 'Mapping (%)', value: 'percentage', sortable: true }
      ],
      mappedData: [],
      pagination: {sortBy: "percentage", descending: true, rowsPerPage: 5},
      loader: false,
      snackbar: {
        message: '',
        display: false,
        color: 'black',
        top: true,
        right: true,
        bottom: false,
        left: false,
        timeout: 2000
      },
      current_date : '',
      total_items: 0,
    }
  },
  methods:{
    getLineWiseMappedData(){

      this.loader = true;
      this.pagination.filters = Object.assign({}, this.filters);
      this.mappedData = [];
      axios.get(`${process.env.VUE_APP_API_URL}/api/v1/get-line-wise-mapping-data`, { params:
        this.pagination,
        headers: this.$headers}).then(response => {
        if (response.data.status == 1) {
          this.mappedData = response.data.data.data;
          this.total_items = response.data.data.total;
          this.loader = false;
        }else{
          this.loader = false;
        }
        }).catch((error) => {
        // console.log(error);
        this.snackbar.message = "Something went wrong.";
        this.snackbar.display = true;
      });
      },

    },
  mounted() {
    this.current_date = moment().format('YYYY-MM-DD');

  }
}
</script>

<style scoped>

</style>
